import getCASMailbox2Operation from 'owa-service/lib/operation/getCASMailbox2Operation';
import GetCASMailboxRequest from 'owa-service/lib/contract/GetCASMailboxRequest';
import GetCASMailboxResponse from 'owa-service/lib/contract/GetCASMailboxResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export async function getCASMailbox2(): Promise<GetCASMailboxResponse> {
    let request: GetCASMailboxRequest = {
        Header: getJsonRequestHeader(),
        Options: {
            ActiveSyncDebugLogging: true,
        },
    };

    let response: GetCASMailboxResponse = await getCASMailbox2Operation(request);
    return response;
}
